import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import { useNotifications } from "reapop";

export const GetAllNavLabels = () => {
  return useQuery({
    queryKey: ["get-all-nav-labels"],
    queryFn: () => client.navLabels.getAll(),
  });
};

export const UpdateNavLabel = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: ({ navKey, label }) => client.navLabels.updateLabel(navKey, label),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Label updated successfully!", "success");
        queryClient.invalidateQueries(["get-all-nav-labels"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update label!", "error");
    },
  });
};
